export default __webpack_public_path__ + "static/media/open-AR.45b3f83d.jpeg";